exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card--3b53G{background:#fff;width:100%;padding:12px;box-sizing:border-box}.borderRadius--2wIZK{border-radius:12px}", ""]);

// Exports
exports.locals = {
	"card": "card--3b53G",
	"borderRadius": "borderRadius--2wIZK"
};